import { render } from "./DatasetConsultForm.vue?vue&type=template&id=fdea5280"
import script from "./DatasetConsultForm.vue?vue&type=script&lang=js"
export * from "./DatasetConsultForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__